import ReceiptPaymentModeSummary from "@/components/receipt-payment-summary/ReceiptPaymentModeSummary";
import type { PaymentSummaryResponse } from "@/components/receipt-payment-summary/types";
import {
  buildLagatSummaryQuery,
  LAGAT_PAYMENT_SUMMARY_PATH,
  LAGAT_SUMMARY_QUERY_KEYS,
  lagatPaymentSummaryCardsFromResponse,
  shouldFetchLagatPaymentSummary,
} from "./lagat-receipt-payment-summary";

const parseLagatPaymentSummaryResponse = (json: unknown): PaymentSummaryResponse | null =>
  json && typeof json === "object" ? (json as PaymentSummaryResponse) : null;

export default function LagatReceiptPaymentSummary() {
  return (
    <ReceiptPaymentModeSummary
      apiResource="lagatReceipts"
      summaryPath={LAGAT_PAYMENT_SUMMARY_PATH}
      queryKeys={LAGAT_SUMMARY_QUERY_KEYS}
      shouldFetch={shouldFetchLagatPaymentSummary}
      buildQuery={buildLagatSummaryQuery}
      parseResponse={parseLagatPaymentSummaryResponse}
      cardsFromResponse={lagatPaymentSummaryCardsFromResponse}
    />
  );
}
